<template>
  <div class="contentBox">
    <div class="nav" :style="'width:' + w">
      <div class="nav_left">
        <div class="icon" @click="goBack">
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
        </div>
        <slot name="nav_left"></slot>
      </div>
      <div class="nav_left">
        <slot name="nav_right"></slot>
      </div>
    </div>
    <div class="content" :style="'height:' + h +';width:' + w">
      <slot></slot>
    </div>
    <yioks-tip :showTip="showTip" :tipMsg="$t('waivedSubmission')" @callback="isBack"></yioks-tip>
  </div>
</template>

<script>

import 'vue-awesome/icons/regular/arrow-alt-circle-left'

export default {
  name: 'SubContent',
  props: {
    h: {
      type: String,
      default: '620px'
    },
    w: {
      type: String,
      default: '890px'
    }
  },
  data () {
    return {
      showTip: false,
      pathArr: ['/squad/addSquad']
    }
  },
  methods: {
    goBack () {
      if (this.pathArr.indexOf(this.$route.path) !== -1) {
        this.showTip = true
      } else {
        this.$emit('back')
      }
    },
    isBack (isSure) {
      if (isSure) {
        this.$emit('back')
      } else {
        this.showTip = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .contentBox
    display flex
    justify-content space-between
    flex-direction column
    align-items center
    height 710px
    width 890px
    .nav
      color #FFF
      height 60px
      background $black_color
      font-size 18px
      width 100%
      display flex
      justify-content space-between
      box-sizing border-box
      user-select none
      .nav_left
        display flex
        align-items center
        .icon
          padding 0 20px
          cursor pointer
      .nav_left
        padding-right 20px
    .content
      color #FFF
      font-size 16px
      height 620px
      // overflow hidden
      background $black_color
      box-sizing border-box
      width 100%
      position relative
      display flex
      flex-direction column
</style>
